import { z } from "zod";
import {
  candidateResumeStageSchema,
  candidateStatusSchema,
} from "../enums.js";
import {
  confidenceSchema,
  isoDateTimeSchema,
  nonEmptyStringSchema,
  uuidSchema,
} from "../primitives.js";

const nullableUrlSchema = z.union([z.string().url(), z.null()]);

export const researchCandidateSchema = z.object({
  id: uuidSchema,
  research_job_id: uuidSchema,
  name: nonEmptyStringSchema,
  website: nullableUrlSchema,
  domain: z.string().nullable(),
  official_website_confidence: confidenceSchema.nullable(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  country: z.string().nullable(),
  discovery_source: z.string().nullable(),
  source_url: nullableUrlSchema,
  status: candidateStatusSchema,
  /** Resume cursor — must be a candidate pipeline stage when set */
  last_completed_stage: candidateResumeStageSchema.nullable(),
  duplicate_of: uuidSchema.nullable(),
  hotel_id: uuidSchema.nullable(),
  stage_error: z.string().nullable(),
  idempotency_key: nonEmptyStringSchema,
  created_at: isoDateTimeSchema,
  updated_at: isoDateTimeSchema,
});

export type ResearchCandidate = z.infer<typeof researchCandidateSchema>;

export const failedResearchCandidateSchema = researchCandidateSchema
  .extend({
    status: z.literal("failed"),
  })
  .superRefine((candidate, ctx) => {
    if (candidate.stage_error === null || candidate.stage_error.trim() === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "failed candidates require stage_error",
        path: ["stage_error"],
      });
    }
  });

export type FailedResearchCandidate = z.infer<typeof failedResearchCandidateSchema>;
